import { FilterDocument, GroupByMode, SortingMode } from '@griply/types';

export const defaultAllTasksFilterDocument: FilterDocument = {
  sortingMode: SortingMode.CreatedAt,
  groupByMode: GroupByMode.LifeArea,
  filters: null,
};
